import React from 'react';

// Ultra-lightweight maintenance page - no external dependencies
export default function MaintenancePage() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#111',
      color: '#fff',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      padding: '0',
      textAlign: 'center'
    }}>
      <div style={{
        width: '100%',
        backgroundColor: '#ffffff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px 0',
        marginBottom: '2rem'
      }}>
        <img 
          src="/scorz-logo.png" 
          alt="Scorz" 
          style={{
            height: '80px',
            width: 'auto'
          }}
        />
      </div>
      <div style={{
        maxWidth: '500px',
        padding: '0 20px'
      }}>
        <h2 style={{
          fontSize: '1.5rem',
          fontWeight: '600',
          marginBottom: '1rem',
          color: '#fff'
        }}>
          Temporarily Unavailable
        </h2>
        <p style={{
          color: '#999',
          fontSize: '0.9rem',
          lineHeight: '1.6'
        }}>
          Sometimes we need to temporarily disable Public Access in order to get full control over results and scores. We're sorry for the inconvenience, but appreciate your understanding whilst Scorz remains under development.
        </p>
      </div>
    </div>
  );
}
